module.exports = __webpack_public_path__ + "static/media/friendly.964a1b82.svg";